import React from 'react';
import {Link} from 'react-router-dom';
import PlayersGoals from '../Widgets/Players/Goals';
import PlayersNumberInTeam from '../Widgets/Players/NumberInTeam';
import PlayersValue from '../Widgets/Players/Value';

export default () => (
  <div id="statistics-players">
    <header className="content-header">
      <h1>
        Statistics
        <small>Players</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-bar-chart" /> Statistics
        </li>
        <li className="text-bold">
          <Link to="/statistics/players">Players</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <PlayersValue />
      <PlayersNumberInTeam />
      <PlayersGoals />
    </section>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Players/index.js